module.exports = __webpack_public_path__ + "img/category-10.d41d8cd9.svg";